// extracted by mini-css-extract-plugin
export default {"record":"PresetValue_record__7GXmN","input":"PresetValue_input__avTcf","delete":"PresetValue_delete__-ulV3","placeHolderShimmer":"PresetValue_placeHolderShimmer__5hwlK"};